// AppraisalStepperForm/Step1BasicDetails.jsx
import { TextField, Box, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useFormikContext, Field } from "formik";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

const Step1BasicDetails = () => {
  const { values, setFieldValue, touched, errors } = useFormikContext();

  const {tagNames} = useSelector((state) => state.appraisal)

  // const tagOptions = useMemo(
  //   () =>
  //     tagNames?.map((tag) => (
  //       <MenuItem key={tag.appraisal_tag_id} value={tag.appraisal_tag_id}>
  //         {tag.appraisal_tag_name}
  //       </MenuItem>
  //     )),
  //   [tagNames]
  // );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6">Basic Details</Typography>

      <Field name="basicDetails.appraisalName">
        {({ field, meta }) => (
          <TextField
            size="small"
            label="Appraisal Name"
            fullWidth
            {...field}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
          />
        )}
      </Field>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Start Date"
          value={dayjs(values.basicDetails.evaluationPeriod.startDate)}
          onChange={(value) =>
            setFieldValue(
              "basicDetails.evaluationPeriod.startDate",
              dayjs(value).format("YYYY-MM-DD")
            )
          }
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              error:
                touched.basicDetails?.evaluationPeriod?.startDate &&
                Boolean(errors.basicDetails?.evaluationPeriod?.startDate),
              helperText:
                touched.basicDetails?.evaluationPeriod?.startDate &&
                errors.basicDetails?.evaluationPeriod?.startDate,
            },
          }}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="End Date"
          value={dayjs(values.basicDetails.evaluationPeriod.endDate)}
          onChange={(value) =>
            setFieldValue(
              "basicDetails.evaluationPeriod.endDate",
              dayjs(value).format("YYYY-MM-DD")
            )
          }
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              error:
                touched.basicDetails?.evaluationPeriod?.endDate &&
                Boolean(errors.basicDetails?.evaluationPeriod?.endDate),
              helperText:
                touched.basicDetails?.evaluationPeriod?.endDate &&
                errors.basicDetails?.evaluationPeriod?.endDate,
            },
          }}
        />
      </LocalizationProvider>
      {/* <FormControl fullWidth size="small">
          <InputLabel id="demo-simple-select-label">Tag</InputLabel>
          <Select
            size="small"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={""}
            name="tag"
            label="Tag"
            onChange={(e) => setLocalTag(e.target.value)}
            sx={{
              borderRadius: 2,
              backgroundColor: "#fff",
            }}
          >
            {tagOptions}
          </Select>
        </FormControl> */}
      <Field name="basicDetails.additionalNotes">
        {({ field, meta }) => (
          <TextField
            label="Additional Notes"
            fullWidth
            size="small"
            multiline
            rows={3}
            {...field}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
          />
        )}
      </Field>
    </Box>
  );
};

export default Step1BasicDetails;
